export enum TeamSnapCalendarType {
    All = 'All',
    Games = 'Games',
}
